import React, { useContext, useMemo, useState } from 'react';

import { IContext, IStorageProvider, STORAGE_NAME } from './consts';
import { Drivers, Storage } from './utils/storage';

export const useStorage = () => {
  return useContext(StorageContext)?.connection;
};

export const StorageContext = React.createContext({
  connection: null,
} as IContext);

export const StorageProvider = ({ children }: IStorageProvider) => {
  const [connection, setConnection] = useState<Storage | null>(null);

  useMemo(() => {
    const setupStore = async () => {
      try {
        const storage = new Storage({
          name: STORAGE_NAME,
          driverOrder: [Drivers.LocalStorage],
        });

        const connection: Storage = await storage.create();

        setConnection(connection);
      } catch (e: any) {}
    };

    setupStore();
  }, [setConnection, Storage, Drivers]);

  return (
    <StorageContext.Provider value={{ connection }}>
      {connection ? children : null}
    </StorageContext.Provider>
  );
};
